module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_2319081.ec39afe5.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/img_on_amazon/FormatoSimplificado_2319081.pdf
// module id = 852
// module chunks = 0